import { RootSelector, getStore } from '../../reducers';
import { VIEW_MODES, ViewModeShape } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { getProjects, getSelectedIds } from '../project/selectors';

const getRoot: RootSelector<ViewModeShape> = createSelector(getStore, (state) => state.viewMode);

export const getViewMode: RootSelector<ViewModeShape['viewMode']> = createSelector(
  getRoot,
  (root) => root.viewMode,
);

export const getExpanded: RootSelector<ViewModeShape['expanded']> = createSelector(
  getRoot,
  (root) => root.expanded,
);

export const getViewModeCollapsed = createSelector([getViewMode], (viewMode) => {
  const result = VIEW_MODES.find(({ key }) => key === viewMode)?.title ?? viewMode;
  return result;
});

export const getViewModeVisible = createSelector(
  [getProjects, getSelectedIds],
  (projects, selectedIds) => {
    const selectedProjects =
      selectedIds.length === 0 ? projects : projects.filter(({ id }) => selectedIds.includes(id));

    // Если выбрано несколько проектов, то не показываем view mode.
    // Если выбран один проект, то смотрим на соответствующий флаг.
    const result = selectedProjects.length === 1 && selectedProjects[0].has_creatives;
    return result;
  },
);
